import { put, takeLatest } from 'redux-saga/effects';
import { ConversationAPI } from 'api/conversations';
import { StoreActionProps } from 'data/core';
import { getConversationAction } from '../actions';
import { fetchStart, fetchSuccess, fetchError } from '../slices';
import { ConversationActionPayload } from '../types';

function* getConversationSaga(
  action: StoreActionProps<ConversationActionPayload>,
) {
  const { projectId, context } = action.payload;

  try {
    yield put(fetchStart(action.payload));

    const { comments, members } = yield ConversationAPI.getComments(
      projectId,
      context,
    );

    yield put(fetchSuccess({ conversation: comments, context, members }));
  } catch (e) {
    yield put(fetchError({ context }));
  }
}

export const watchGetConversationSaga = function* (): Generator {
  yield takeLatest(getConversationAction.type, getConversationSaga);
};
